<script setup lang="ts">
    defineProps({
        legend: {
            type: String,
            default: undefined,
        },
    })
</script>

<template>
    <fieldset class="pk-fieldset">
        <legend v-if="legend || $slots.legend">
            <slot name="legend">
                {{ legend }}
            </slot>
        </legend>
        <slot />
    </fieldset>
</template>

<style lang="scss">
    @layer volver.components {
        .pk-fieldset {
            border: var(--spacing-px) solid var(--color-surface-3);
            border-radius: var(--rounded);
            padding-top: var(--spacing-md);
            padding-bottom: var(--spacing-md);
            padding-inline: var(--spacing-md);
            margin-bottom: var(--input-gap);

            & > legend {
                font-size: var(--text-12);
                color: var(--color-word-2);
                background-color: var(--color-surface);
                padding-inline: var(--spacing-8);
            }
        }
    }
</style>
